module.exports = __webpack_public_path__ + "img/vista_1.45515b50.png";